import styles from "./SelectDoorType.module.scss";
import QuestionMarkIcon from "../../assets/icons/question_mark3.svg";
import { DoorType } from "../../common/CommonType";
import { SearchConfActionType, useConfig } from "../../reducers/searchConfReducer";
import { useEffect, useRef, useState } from "react";
import DoorInfoModal from "../Modal/DoorInfoModal";
import NoDoorModal from "../Modal/NoDoorModal";
import { TopToast } from "../Toast/TopToast";
import SaleTip from "@/components/AbtestSaleTip/AbtestSaleTip";
import { GIO, GioModuleVar } from "@/utils/gioUtils";

function SelectDoorType(props: {
  isSliderOutOfStock?: boolean
}) {
  const { isSliderOutOfStock = false } = props;
  const { state, dispatch } = useConfig();
  const [isShowToast, setIsShowToast] = useState(false)
  const timer1: any = useRef()

  const [openInfo, setOpenInfo] = useState(false)

  function handleClick(type: DoorType) {
    if (type === DoorType.SLIDING) {
      setIsShowToast(true)
      timer1.current = setTimeout(() => {
        setIsShowToast(false);
      }, 2000);
    }
    GIO('track', 'clickData', {
      eventType_var: 'click',
      module_var: GioModuleVar.doortypeChoose,
      objectName_var: type === DoorType.HINGE ? '合叶门' :
                        type === DoorType.SLIDING  ? '滑门' : '无门'

    })
    dispatch({
      type: SearchConfActionType.UpdateConfig,
      payload: Object.assign(state, { doorType: type })
    })
  }

  function handleNoDoorTipClose() {
    dispatch({
      type: SearchConfActionType.UpdateDoorTipTime,
      payload: null
    })
  }
  useEffect(() => {
    return () => {
      if (timer1.current) window.clearTimeout(timer1.current)
    }
  }, [])


  return (
    <div>
      <div className={styles.Label}>
        <span>门型</span>
        <img onClick={() => {
          setOpenInfo(true)
        }} src={QuestionMarkIcon} className={styles.QuestionMark} alt="question_mark"/>
      </div>
      <div className={styles.optionWrap}>
        <div className={`${styles.DoorTypeOption} ${state.doorType === DoorType.HINGE ? styles.Active : ""}`}
             onClick={() => handleClick(DoorType.HINGE)}>
          <div className={styles.DoorTypeIcon + " " + styles.Hinge}/>
          <span>合页门</span>
          <SaleTip text="78%顾客选择"></SaleTip>
        </div>

        <div className={`${styles.DoorTypeOption} ${state.doorType === DoorType.SLIDING ? styles.Active : ""}`}
             onClick={() => handleClick(DoorType.SLIDING)}>
          <div className={styles.DoorTypeIcon + " " + styles.Slide}/>
          <span>滑门</span>
          <SaleTip text="19%顾客选择"></SaleTip>
          {
            isSliderOutOfStock && <div className={styles.outOfStock}>当前尺寸缺货</div>
          }
        </div>

        <div className={`${styles.DoorTypeOption} ${state.doorType === DoorType.NONE ? styles.Active : ""}`}
             onClick={() => handleClick(DoorType.NONE)}>
          <div className={styles.DoorTypeIcon + " " + styles.NoDoor}/>
          <span>无门</span>
        </div>
      </div>
      <DoorInfoModal open={openInfo} onClose={() => {
        setOpenInfo(false)
      }}/>
      <NoDoorModal open={state.showDoorTip} onClose={handleNoDoorTipClose} />
      {isShowToast && <TopToast
        desc="滑门只支持150,200,300宽度的衣柜。"
        onClose={() => setIsShowToast(false)}
      ></TopToast>}
    </div>)
}

export default SelectDoorType;
